module.exports = __webpack_public_path__ + "static/media/ombre-white-full.01f24b7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/static/images/ombre-white-full.svg
// module id = 61
// module chunks = 1